<template lang="pug">
  .root
    the-heading(:breadcrumbs="breadcrumbs" :caption="'Результаты анализа данных пациента №' + values.id")
    .container
      .main_block
        .caption
          .globalCaptionStyles(style="margin-top: 100px") Результаты анализа данных пациента №{{values.id}}

        RequestTabs(:values="values" v-if="this.values !== false")

        .buttons
          button.more_btn(@click="toggleGrade = !toggleGrade; toggleData = false; docAndDiag = false")
            span(v-if="!toggleGrade") Оценить систему
            span(v-if="toggleGrade") Скрыть оценку системы
          button.more_btn(@click="toggleData = !toggleData; toggleGrade = false; docAndDiag = false")
            span(v-if="!toggleData") Показать исходные данные
            span(v-if="toggleData") Скрыть исходные данные
          button.more_btn(@click="docAndDiag = !docAndDiag; toggleGrade = false; toggleData = false")
            span(v-if="!docAndDiag") Показать исходные документы и диагнозы
            span(v-if="docAndDiag") Скрыть исходные документы и диагнозы
          button.grade_btn(v-if="showEditButton" @click="editForm")
            v-icon(name="pencil-alt")

        transition(name="fade")
          .dataBlock(v-if="toggleData")
            RequestSourseData(:values="values")
          .dataBlock(v-if="docAndDiag")
            RequestDocumentsAndDiagnosis(:values="values" prevState="RequestSummary")
          .GradeBlock(v-if="toggleGrade")
            .data_header(v-if="!values.result_correctness && !is_set_grade") Ваша оценка сделает систему лучше
              .fields
                .fields_item
                  label Ваше общее впечатление о сервисе *
                  .radioBtn
                    measure-radio-button(:options="checkboxData" :name="'service'" v-model.number="grade.service")
                .fields_item
                  label Ваша оценка предложенных рекомендаций *
                  .radioBtn
                    measure-radio-button(:options="checkboxData" :name="'recommendations'" v-model.number="grade.recommendations")
                .fields_item.item_left
                  label Комментарий
                    textarea.textarea(placeholder="Здесь Вы можете указать пожелания по работе системы и комментарий" v-model="grade.wishes")
                .fields_item.item_left
                  button.submitBtn(@click="sendGrade") Отправить
            .data_header(v-if="values.result_correctness || is_set_grade") Ваша оценка работы системы
              .grade_block
                .grade_header Ваше общее впечатление о сервисе
                .grade_text {{grade.service || values.result_correctness}}
                .grade_header Ваша оценка предложенных рекомендаций
                .grade_text {{grade.recommendations || values.recommendation_correctness}}
                .grade_header Комментарий
                .grade_text {{grade.wishes || values.wishes_correctness}}

        .disclaimer Данные «Webiomed» и любая информация, предоставленная в отношении программного продукта, предназначены только для информационных целей и не должны быть использованы для замены профессиональных медицинских консультаций. Окончательная постановка диагноза, назначение лечения и профилактических осмотров осуществляются врачом.
    the-footing
</template>
<script>
import axios from 'axios'
import Icon from 'vue-awesome/components/Icon'
import MeasureRadioButton from '../fields/MeasureRadioButton'
import TheHeading from '@/components/parts/TheHeading'
import TheFooting from '@/components/parts/TheFooting'
import breadcrumbs from '@/data/breadcrumbs/AnalysisSummary'

export default {
  components: {
    MeasureRadioButton,
    'v-icon': Icon,
    TheHeading,
    TheFooting,
    RequestSourseData: () =>
      import('@//components/parts/RequestSourseData'),
    RequestDocumentsAndDiagnosis: () =>
      import('@//components/parts/RequestDocumentsAndDiagnosis'),
    RequestTabs: () =>
      import('@//components/parts/RequestTabs')
  },
  data () {
    axios
      .get('dhra/api/v1/system/about/')
      .then(result => {
        this.isProd = result.data.prod
      })
    return {
      showEditButton: this.$route.query.e ? true : false,
      breadcrumbs,
      is_set_grade: false,
      toggleData: false,
      toggleGrade: false,
      docAndDiag: false,
      values: false,
      grade: {},
      checkboxData: [
        {
          label: '1',
          value: 1
        },
        {
          label: '2',
          value: 2
        },
        {
          label: '3',
          value: 3
        },
        {
          label: '4',
          value: 4
        },
        {
          label: '5',
          value: 5
        }
      ],
      isProd: false
    }
  },
  methods: {
    showNewDesign () {
      window.open(`/newdesign/#/dhra/requests/${this.values.id}`, '_blank')
    },
    setData (response) {
      this.values = response
    },
    sendGrade () {
      let params = {
        id: this.values.id,
        recommendation_correctness: this.grade.recommendations,
        result_correctness: this.grade.service,
        wishes_correctness: this.grade.wishes
      }
      axios.put('dhra/api/v2/webiomedmpi/requests/' + this.values.id + '/', params).then(
        response => {
          this.is_set_grade = true
          this.$notify({
            text: 'Спасибо, что оценили систему!',
            type: 'sucsess'
          })
        },
        error => {
          this.$notify({
            text:
              'Укажите оценку системы и правильность предоставленных рекомендаций',
            type: 'warn'
          })
        }
      )
    },
    editForm () {
      this.$store
        .dispatch('setForm', this.values)
        .then(() => {
          this.$router.push({
            name: 'Analysis',
            query: {
              t: this.$route.query.t,
              savedForm: this.values.id
            }
          })
        })
        .catch(error => {
          console.error('error')
        })
    }
  },
  beforeRouteEnter (to, from, next) {
    axios.get('dhra/api/v3/webiomedmpi/requests/' + to.params.id + '/').then(values => {
      axios
        .get('symptom-checker/api/groups-images-list/')
        .then(
          response => {
            values.data.images = response.data
          }
        )
      axios
        .get('symptom-checker/api/rules-groups-list/')
        .then(
          response => {
            values.data.groups = response.data
            next(vm => vm.setData(values.data))
          }
        )
    })
  }
}
</script>
<style lang="sass" scoped>
@import "@/css/pageSummaryStyles2.sass"
.grade_text
  color: #212121
  font-size: 18px
  font-weight: 400
.radioBtn
  margin-top: 10px
.textarea
  margin-top: 10px
.submitBtn
  padding: 14px 18px
  font-family: 'Roboto', Helvetica, Arial, sans-serif
  font-size: 16px
  font-weight: bold
  background: #2793a7
  color: white
  border: none
  border-radius: 50px
  cursor: pointer
.submitBtn:hover
  transition: all, 0.3s
  background: #1d6c7a
.submitBtn:disabled
  cursor: not-allowed
  background: #1d6c7a
  opacity: .65
  color: #fff
  transition: all, 0.3s

// LOD BLOCK
.lod_block
  background: #ebf7f9
  margin-top: 20px
  margin-bottom: 50px
  padding: 10px 15px
  font-size: 16px
  font-weight: 400
  color: #212121
  border-radius: 10px
.lod
  line-height: 35px
  font-size: 17px
a:hover
  text-decoration: underline
  cursor: pointer
</style>
